<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div v-if="product" class="dialog type-product-detail">
        <header class="dialog-header">
          <h2 class="sr-only">제품상세 팝업</h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">제품상세</h3>

            <div class="m-product-detail">
              <!-- D: product compentnt -->
              <div class="c-products type-detail">
                <!-- D: 서브 전용 상품 컴포넌트 -->
                <div class="c-product-card">
                  <div class="product-thumb">
                    <div class="thumb-button">
                      <div class="product-img">
                        <img
                          v-if="isNoPcImage"
                          src="@/assets/images/common/img_no_product.svg"
                          alt="No Image"
                          class="no-image"
                        />
                        <img
                          v-else
                          :src="imageFilePath"
                          alt=""
                          @error="() => (imageErrorYn = true)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="product-info">
                    <div v-show="!productBadgeEmptyYn" class="c-product-badge">
                      <span
                        v-show="product.setgdYn === 'Y'"
                        class="badge type-skyblue"
                      >
                        SET 제품
                      </span>

                      <span
                        v-if="product.zzlqdCls == 'A'"
                        class="badge type-purple"
                      >
                        주제
                      </span>
                      <span
                        v-if="product.zzlqdCls == 'B'"
                        class="badge type-mint"
                      >
                        경화제
                      </span>
                      <span
                        v-if="product.zzlqdCls == 'C'"
                        class="badge type-blue"
                      >
                        경화촉진제
                      </span>
                      <span
                        v-if="product.zzlqdCls == 'D'"
                        class="badge type-violet"
                      >
                        회석제
                      </span>

                      <span
                        v-if="product.zzlqdtyCls == 'A'"
                        class="badge type-olive"
                      >
                        1액형
                      </span>
                      <span
                        v-if="product.zzlqdtyCls == 'B'"
                        class="badge type-olive"
                      >
                        2액형
                      </span>
                      <span
                        v-if="product.zzlqdtyCls == 'C'"
                        class="badge type-olive"
                      >
                        3액형
                      </span>
                    </div>
                    <div class="c-product-category">
                      <span class="path">{{ product.prodh1t }}</span>
                      <span class="path">{{ product.prodh2t }}</span>
                      <span class="path">{{ product.prodh3t }}</span>
                    </div>
                    <div class="product-code">{{ product.matnr }}</div>
                    <strong class="product-name">
                      {{ product.zzmaktx }}
                    </strong>
                    <div class="info-bottom">
                      <div class="info-detail">
                        <div class="detail-item">
                          <strong class="label">금액</strong>
                          <div class="ct">
                            <p class="price">
                              <strong class="system">
                                {{ Utils.currency(product.kbetr) }} </strong
                              >원
                            </p>
                          </div>
                        </div>
                        <div class="detail-item">
                          <strong class="label">수량</strong>
                          <div class="ct">
                            <!-- <button
                              type="button"
                              class="stock"
                              @click="data.totalStockListPopEl = true"
                            >
                              재고조회
                            </button> -->
                            <div class="c-counter">
                              <button
                                type="button"
                                class="btn-minus"
                                @click="() => (quantity -= 1)"
                                :disabled="quantity <= 1"
                              >
                                <i class="c-icon icon-minus size-xxsmall"></i>
                                <span class="sr-only">빼기</span>
                              </button>
                              <input
                                v-model="quantity"
                                type="number"
                                title="수량입력"
                                ref="myInput"
                                @mousedown="handleMouseDown"
                              />
                              <button
                                type="button"
                                class="btn-plus"
                                @click="() => (quantity += 1)"
                                :disabled="quantity >= 99999"
                              >
                                <i
                                  class="c-icon icon-plus-black size-xxsmall"
                                ></i>
                                <span class="sr-only">더하기</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="detail-item type-total">
                          <strong class="label">총 금액</strong>
                          <div class="ct">
                            <p class="price">
                              {{ Utils.currency(totalAmount) }}원
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="c-btn-area">
                        <button
                          type="button"
                          class="c-button type-secondary type-xsmall"
                          @click="onCartRequest"
                        >
                          <span>장바구니</span>
                        </button>
                        <button
                          type="button"
                          class="c-button type-primary type-xsmall"
                          @click="onBuyRequest"
                        >
                          <span>바로주문</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="c-tabs">
                <ul>
                  <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
                  <li class="tab-item">
                    <a
                      href="#tab3-1"
                      class="tab-anchor"
                      :class="{ 'is-active': selectedTab === 'PROD' }"
                      role="tab"
                      @click.prevent="() => (selectedTab = 'PROD')"
                    >
                      제품정보
                    </a>
                  </li>
                  <li class="tab-item">
                    <a
                      href="#tab3-2"
                      class="tab-anchor"
                      :class="{ 'is-active': selectedTab === 'RELATE' }"
                      role="tab"
                      @click.prevent="() => (selectedTab = 'RELATE')"
                    >
                      관련문서
                    </a>
                  </li>
                  <li class="tab-item" v-if="product.linkList.length > 0">
                    <a
                      href="#tab3-3"
                      class="tab-anchor"
                      :class="{ 'is-active': selectedTab === 'VIDEO' }"
                      role="tab"
                      @click.prevent="() => (selectedTab = 'VIDEO')"
                    >
                      영상링크
                    </a>
                  </li>
                </ul>
              </div>
              <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
              <div class="c-tab-panel-wrap">
                <!-- tab content: tab1 -->
                <div
                  class="tab-panel"
                  role="tabpanel"
                  aria-labelledby="tab3-1"
                  :hidden="selectedTab !== 'PROD'"
                >
                  <ProdInfoTab :product="product" />
                </div>
                <!-- tab content: tab2 -->
                <div
                  class="tab-panel"
                  role="tabpanel"
                  aria-labelledby="tab3-2"
                  :hidden="selectedTab !== 'RELATE'"
                >
                  <RelatedDocTab v-if="product" :files="product.fileList" />
                </div>
                <!-- tab content: tab3 -->
                <div
                  class="tab-panel"
                  role="tabpanel"
                  aria-labelledby="tab3-3"
                  :hidden="selectedTab !== 'VIDEO'"
                >
                  <VideoLinkTab v-if="product" :links="product.linkList" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- D: MO에서만 노출 -->
        <div class="dialog-footer only-mo">
          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-secondary"
              @click="onCartRequest"
            >
              <span>장바구니</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              @click="onBuyRequest"
            >
              <span>바로주문</span>
            </button>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>

  <AlertWerks
    :totalStockListPopEl="data.totalStockListPopEl"
    :product="product"
    :werks="CODE_WERKS"
    @close="() => (data.totalStockListPopEl = false)"
  >
  </AlertWerks>

  <AlertPopup ref="shareSelectPopEl">
    <template #content>
      <div class="text-wrap">
        <p class="text ac">해당파일 공유하기</p>
        <div class="btn-wrap">
          <button type="button" class="c-btn-icon" @click="mailFileLink">
            <i class="c-icon icon-mail"></i>
            <span class="sr-only">메일 공유</span>
          </button>
          <button type="button" class="c-btn-icon" @click="copyFileLink">
            <i class="c-icon icon-link"></i>
            <span class="sr-only">링크 복사</span>
          </button>
        </div>
        <!-- D: 닫기 케이스 -->
        <button
          type="button"
          class="dialog-close"
          @click="() => shareSelectPopEl.closePopup()"
        >
          <span class="c-icon icon-small-x"></span>
          <span class="sr-only">닫기</span>
        </button>
      </div>
    </template>
  </AlertPopup>
</template>
<script setup>
import {
  onMounted,
  defineEmits,
  defineProps,
  inject,
  ref,
  computed,
  provide,
  readonly,
  watch,
  reactive,
} from "vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import ProdInfoTab from "@/components/paintpro/prod/prodInfoTab.vue";
import RelatedDocTab from "@/components/paintpro/prod/relatedDocTab.vue";
import VideoLinkTab from "@/components/paintpro/prod/videoLinkTab.vue";
import { api } from "@/plugins/api";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil";
import * as cmApi from "@/api/cmApi";
import AlertPopup from "@/components/paintpro/common/alert.vue";
import AlertWerks from "@/components/paintpro/common/AlertWerks.vue";

const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;

const url = inject("url_prefix");
const addBuyItem = inject("addBuyItem");
const addCartItem = inject("addCartItem");

const emits = defineEmits(["close"]);

const selectedTab = ref("PROD"); // PROD / RELATE / VIDEO
const CODE_WERKS = ref([]);

const CODE_GOODS_FILE_SE_CD = ref([]);
provide("CODE_GOODS_FILE_SE_CD", readonly(CODE_GOODS_FILE_SE_CD));

const userLoginInfo = ref(null);

const props = defineProps({
  matnr: {
    type: String,
    required: true,
  },
});

const data = reactive({
  totalStockListPopEl: false,
});

const product = ref(null);
const shareSelectPopEl = ref();
const targetShareFile = ref(null);
const quantity = ref(1);
const imageErrorYn = ref(false);
const myInput = ref(null);

onMounted(async () => {
  await initPage();
  loadProduct();
});

watch(quantity, (curr, prev) => {
  if (curr < 1) {
    quantity.value = 1;
  } else if (curr > 99999) {
    quantity.value = prev;
  }
});

const productBadgeEmptyYn = computed(() => {
  return (
    product.value.setgdYn !== "Y" &&
    product.value.zzlqdCls !== "A" &&
    product.value.zzlqdCls !== "B" &&
    product.value.zzlqdCls !== "C" &&
    product.value.zzlqdCls !== "D" &&
    product.value.zzlqdtyCls !== "A" &&
    product.value.zzlqdtyCls !== "B" &&
    product.value.zzlqdtyCls !== "C"
  );
});

const totalAmount = computed(() => {
  if (!product.value) return 0;

  return product.value.kbetr * quantity.value;
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(product.value.imgFilePath) ||
    Utils.isBlank(product.value.imgFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return (
    FILE_CDN_URL +
    "/" +
    product.value.imgFilePath +
    "/" +
    product.value.imgFileNm
  );
});

const initPage = async () => {
  const res = await cmApi.getPageInitData([
    { qId: "cmCode_code1", parm: { cdGrp: "WERKS" } },
    { qId: "cmCode_code2", parm: { cdGrp: "GOODS_FILE_SE_CD" } },
  ]);

  const { resultCode } = res;
  if (resultCode !== 200) {
    return false;
  }
  CODE_WERKS.value = res.data.cmCode_code1;
  CODE_GOODS_FILE_SE_CD.value = res.data.cmCode_code2;

  userLoginInfo.value = res.data.userLoginInfo;
};

const loadProduct = async () => {
  const res = await api.get(
    `${url}/product/item/${Utils.replace(props.matnr, "/", "-")}`
  );

  const { resultCode } = res;
  if (resultCode !== 200) {
    emits("close");
    return;
  }

  product.value = res.data;

  cmApi.insertUserRecentlyProd({ goodsSn: product.value.goodsSn });
};

const showShareSelectPop = (file) => {
  targetShareFile.value = file;
  shareSelectPopEl.value.openPopup();
};
provide("showShareSelectPop", showShareSelectPop);

const copyFileLink = () => {
  shareSelectPopEl.value.closePopup();

  const fileUrl = targetShareFile.value.filePath.startsWith("http")
    ? targetShareFile.value.filePath
    : FILE_CDN_URL +
      targetShareFile.value.filePath +
      "/" +
      targetShareFile.value.physFileNm;

  window.navigator.clipboard.writeText(fileUrl).then(async () => {
    await cmUtil.alert("해당 파일의 주소가 복사되었습니다.");
  });
};

const mailFileLink = () => {
  shareSelectPopEl.value.closePopup();

  const fileUrl = targetShareFile.value.filePath.startsWith("http")
    ? targetShareFile.value.filePath.startsWith("http")
    : FILE_CDN_URL +
      targetShareFile.value.filePath +
      "/" +
      targetShareFile.value.physFileNm;

  const mailto = userLoginInfo.value?.email || "";

  window.location.href = `mailto:${mailto}?subject=${targetShareFile.value.orgnlFileNm}&body=${fileUrl}`;
};

const onBuyRequest = async () => {
  if (quantity.value === 0) {
    await cmUtil.alert("최소 주문 수량은 1개입니다. 0은 주문할 수 없습니다.");
    return;
  }

  addBuyItem({ ...product.value, quantity: quantity.value });
  emits("close");
};

const onCartRequest = async () => {
  if (quantity.value === 0) {
    await cmUtil.alert("최소 주문 수량은 1개입니다. 0은 주문할 수 없습니다.");
    return;
  }
  addCartItem({ product: { ...product.value }, quantity: quantity.value });
};

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};
</script>
